var exports = {
  "az": "Box__6lpBRr",
  "wy": "Box_1__CzsAnb",
  "pv": "Box_2__zaRucd",
  "w9": "Box_3__Na7qEQ",
  "Ou": "UnderlineNav__9sm8Cc",
  "r9": "editButton__tKaHj8",
  "wK": "readmeHeaderSlot__EGBTUW",
  "Hh": "ActionMenu_Button__Q94vxS",
  "rq": "ActionMenu_Overlay__Lr_-a_",
};

module.exports = exports;
